// vy-0914-resp-all-subscription-billing-small-controls-768: the tier-card
// feature-row (i) info icon is a hover/tap tooltip trigger, but it painted as
// a bare 16x16 svg -- MEASURED live on web-stg /settings?tab=subscriptions at
// 768x1024 (main.c9b51ab2.js, 2026-10-02): 11 of these at 16x16, the only
// sub-32px controls left on the tab. The glyph stays 16px (design size); the
// svg gets 8px of transparent padding (content-box) so its hit box is 32x32,
// and an equal negative margin so the row's layout footprint does not move.
// Padding on the svg itself, NOT a wrapper element: MUI Tooltip clones its
// single child, and SubscriptionItem's tests rely on the icon's parentElement
// being the FeatureItem row.
export const FEATURE_INFO_ICON_PX = 16;
export const FEATURE_INFO_HIT_PX = 32;
const PAD_PX = (FEATURE_INFO_HIT_PX - FEATURE_INFO_ICON_PX) / 2;

export function featureInfoIconStyle(color) {
  return {
    fontSize: `${FEATURE_INFO_ICON_PX}px`,
    color,
    cursor: "pointer",
    boxSizing: "content-box",
    padding: `${PAD_PX}px`,
    margin: `-${PAD_PX}px`,
    flexShrink: 0,
  };
}

// Hit-box edge (px) a style object produces: glyph + padding on both sides.
export function hitBoxPx(style) {
  const glyph = parseFloat(style.fontSize) || 0;
  const pad = parseFloat(style.padding) || 0;
  return style.boxSizing === "content-box" ? glyph + 2 * pad : glyph;
}

// Layout footprint (px) a style object takes in the row: hit box + both margins.
export function footprintPx(style) {
  const margin = parseFloat(style.margin) || 0;
  return hitBoxPx(style) + 2 * margin;
}
